import { BIP32Factory } from 'bip32';
import * as ecc from '@bitcoinerlab/secp256k1';

// Pure-JS secp256k1 backing for bip32 v4; replaces the wasm tiny-secp256k1
// pulled by bip32 v2. Derivation output is byte-identical.
const bip32 = BIP32Factory(ecc);

export default bip32;
